var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import IconContainer, { IconSVG } from "./IconContainer";
var IconDataPrivacy = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("path", { d: "M15,27.9c0,0,10.4-5.2,10.4-12.9V5.9L15,2.1L4.6,5.9V15C4.6,22.8,15,27.9,15,27.9z" }),
            React.createElement("g", { transform: "translate(1.25 1.785)" },
                React.createElement("path", { d: "M20,17.9v-1.5c0-1.7-1.4-3-3-3l0,0h-6.1c-1.7,0-3,1.4-3,3l0,0v1.5" }),
                React.createElement("path", { d: "M17,7.3c0,1.7-1.4,3-3,3s-3-1.4-3-3c0-1.7,1.4-3,3-3C15.6,4.2,17,5.6,17,7.3\n\t\tC17,7.3,17,7.3,17,7.3z" })))));
});
export default IconDataPrivacy;
//# sourceMappingURL=IconDataPrivacy.js.map